import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import UserAvatar from './UserAvatar';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { currentUser, userProfile, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50 py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-32 py-4">
          {/* Logo and Brand */}
          <div className="flex items-center">
            <Link to={currentUser ? "/ideas" : "/"} className="flex items-center space-x-2">
              <img 
                src="/assets/images/EVC Logo.png" 
                alt="Expected Value Club" 
                className="h-28"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/ideas"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Ideas
            </Link>
            <Link
              to="/leaderboard"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Leaderboard
            </Link>

            <Link
              to="/about"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              About
            </Link>
            {userProfile?.role === 'admin' && (
              <Link
                to="/admin"
                className="text-purple-600 hover:text-purple-700 transition-colors font-medium"
              >
                Admin
              </Link>
            )}
          </div>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            {currentUser ? (
              <>
                <Link
                  to="/submit-idea"
                  className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
                >
                  + Submit Idea
                </Link>
                <UserAvatar size="md" />
                <button
                  onClick={handleLogout}
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="btn-primary"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-gray-900 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <Link
              to="/ideas"
              className="block px-4 py-2 text-gray-600 hover:bg-gray-50 rounded"
            >
              Ideas
            </Link>
            <Link
              to="/leaderboard"
              className="block px-4 py-2 text-gray-600 hover:bg-gray-50 rounded"
            >
              Leaderboard
            </Link>

            <Link
              to="/about"
              className="block px-4 py-2 text-gray-600 hover:bg-gray-50 rounded"
            >
              About
            </Link>
            {userProfile?.role === 'admin' && (
              <Link
                to="/admin"
                className="block px-4 py-2 text-purple-600 hover:bg-purple-50 rounded font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Admin Dashboard
              </Link>
            )}
            <div className="pt-2 space-y-2">
              {currentUser ? (
                <>
                  <Link
                    to="/submit-idea"
                    className="block px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium text-center"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    + Submit Idea
                  </Link>
                  <div className="flex items-center px-4 py-2" onClick={() => setIsMenuOpen(false)}>
                    <UserAvatar size="sm" showTooltip={false} />
                    <span className="ml-3 text-gray-600">Dashboard</span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-gray-600 hover:bg-gray-50 rounded"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="block px-4 py-2 text-gray-600 hover:bg-gray-50 rounded"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="block btn-primary text-center"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

